class Hex {
  constructor(q, r, s, isWall = false) {
    this.q = q;
    this.r = r;
    this.s = s;
    this.isWall = isWall;
  }

  setWall(isWall) {
    this.isWall = isWall;
  }
}

export default Hex;
